const Navigation = () => {
  return (
    <div className="Navigation">
      <ul>
        <li>
          <a href="/creatures" className="nav-guests"></a>
        </li>
        <li>
          <a href="/parties" className="nav-parties"></a>
        </li>
        <li>
          <a href="/about" className="nav-about"></a>
        </li>
        <li>
          <a href="/join-us" className="nav-join"></a>
        </li>
      </ul>
    </div>
  );
};

export default Navigation;
